import { ChevronDown, ChevronUp, Lightbulb } from "lucide-react";
import { Link } from "react-router-dom";
import type { IdeaRow } from "../types";
import { Card, CardHeader, Empty, SkeletonRow, ViewAllLink } from "./_shared";

type Props = {
  ideas: IdeaRow[];
  isLoading?: boolean;
};

const MEDAL_COLOR = ["hsl(45,80%,50%)", "hsl(210,8%,55%)", "hsl(22,60%,45%)"];

export function IdeasLeaderboardWidget({ ideas, isLoading }: Props) {
  return (
    <Card>
      <CardHeader
        icon={
          <Lightbulb
            className="h-4 w-4 text-[hsl(38,92%,50%)]"
            strokeWidth={1.5}
          />
        }
        title="Top Ideas"
        count={ideas.length}
        action={<ViewAllLink href="/ideas" />}
      />
      {isLoading ? (
        <div>
          {[0, 1, 2].map((i) => (
            <SkeletonRow key={i} />
          ))}
        </div>
      ) : ideas.length === 0 ? (
        <Empty
          icon={
            <Lightbulb
              className="h-8 w-8 text-muted-foreground opacity-40"
              strokeWidth={1.5}
            />
          }
          text="No ideas yet"
        />
      ) : (
        <ul className="divide-y" style={{ borderColor: "hsl(210,30%,92%)" }}>
          {ideas.slice(0, 5).map((idea, i) => {
            const rankColor = i < 3 ? MEDAL_COLOR[i] : "hsl(215,16%,47%)";
            return (
              <li key={idea.id}>
                <Link
                  to={`/ideas/${idea.id}`}
                  className="flex items-center gap-2 py-2 hover:bg-[hsl(210,50%,98%)]"
                >
                  <span
                    className="w-5 shrink-0 text-center text-[13px] font-bold"
                    style={{ color: rankColor }}
                  >
                    {i + 1}
                  </span>
                  <span className="truncate text-[13px] font-medium text-foreground">
                    {idea.title}
                  </span>
                  <span className="ml-auto flex shrink-0 items-center gap-2 text-[11px]">
                    <span
                      className="inline-flex items-center gap-0.5 text-[hsl(142,72%,28%)]"
                    >
                      <ChevronUp className="h-3 w-3" strokeWidth={1.8} />
                      {idea.votesUp}
                    </span>
                    <span
                      className="inline-flex items-center gap-0.5 text-[hsl(0,70%,40%)]"
                    >
                      <ChevronDown className="h-3 w-3" strokeWidth={1.8} />
                      {idea.votesDown}
                    </span>
                  </span>
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </Card>
  );
}
